import { ProblemRowData } from "common/components/ProblemsTable/types";

export const getIsUnacknowledgedProblemRow = (row: ProblemRowData) => !row.acknowledgedAt;
